import { NgModule } from "@angular/core";

import { PushNotificationModule } from "./push-notification/push-notification.module";

export { NotificationHeaderComponent } from "./push-notification/components/notification-header/notification-header.component";
export { PushNotificationStatus } from "./push-notification/models/push-notification-status.enum";
export { PushNotification, PushNotificationPayload } from "./push-notification/models/push-notification.model";
export { PushNotificationModule } from "./push-notification/push-notification.module";
export {
    PUSH_NOTIFICATION_CONFIG,
    PushNotificationConfig,
    PushNotificationsService,
} from "./push-notification/services/push-notification.service";
export { PushNotificationActions } from "./push-notification/states/push-notification.actions";
export { PushNotificationSelectors } from "./push-notification/states/push-notification.selectors";
export { PushNotificationState } from "./push-notification/states/push-notification.state";

@NgModule({
    imports: [PushNotificationModule],
    exports: [PushNotificationModule],
})
export class FeatureNotificationModule {}
